<template>
  <div class="login-form-container">
    <h1 class="login-form-card-title">Log in to {{ $t("brandName") }}</h1>
    <a-form
      ref="loginForm"
      :form="form"
      layout="vertical"
      :action="samlAuthPath"
      :style="{ marginBottom: '4px' }"
      method="POST"
      @submit.stop.prevent="handleSubmit"
    >
      <input type="hidden" name="authenticity_token" :value="csrfToken" />
      <a-form-item>
        <span slot="label">Email</span>
        <a-input
          v-decorator="[
            'email',
            { rules: [{ required: true, message: 'Enter your email' }] },
          ]"
          name="username"
          autoFocus
        />
      </a-form-item>
      <a-button type="primary" htmlType="submit">Log in</a-button>
    </a-form>
    <a v-if="recoverable" id="forgot-password-link" :href="resetPasswordUrl">
      Forgot your password?
    </a>
    <a-divider />
    <a-button @click="redirectToNonSSOLogin">Log in with Password</a-button>
    <span v-if="showSignUpLink" class="sign-up-prompt">
      Don't have an account?
      <br />
      <a href="https://www.opslevel.com/request-a-demo" target="_blank">
        Schedule a time to meet with our team.
      </a>
    </span>
  </div>
</template>

<script>
import csrf from "@/lib/csrf.js";
import { isSelfHosted } from "@/shared/helpers.js";

export default {
  inject: {
    brand: { default: "opslevel" },
  },

  props: {
    urls: {
      type: Object,
      required: true,
      validator: (urls) => {
        return (
          typeof urls.session === "string" &&
          typeof urls.users === "object" &&
          typeof urls.password == "object"
        );
      },
    },
    recoverable: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      form: this.$form.createForm(this, {
        name: "login",
      }),
    };
  },

  computed: {
    csrfToken() {
      return csrf.token;
    },
    sessionUrl() {
      return this.urls.session;
    },
    resetPasswordUrl() {
      return this.urls.password.new;
    },
    samlAuthPath() {
      return this.urls.users.saml_auth_path;
    },
    showSignUpLink() {
      return this.brand === "opslevel" && !isSelfHosted();
    },
  },

  methods: {
    handleSubmit() {
      this.form.validateFields(async (err) => {
        if (!err) {
          // Instead of submitting this through axios, we are doing a regular form submission here.
          // This is because Devise will return a 302 Found, and redirect us to the login page.
          // Devise also flashes a helpful message letting you know that you can expect to receive an email
          // but axios swallows that message.
          this.$refs.loginForm.$el.submit();
        }
      });
    },
    redirectToNonSSOLogin() {
      window.location.assign(this.sessionUrl);
    },
  },
};
</script>

<style scoped>
@import "login.css";
</style>
